import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Col, Row, Card, Button } from 'react-bootstrap';
import '../assets/css/Recruiter.css';
import '../assets/css/Form.css';
import '../assets/css/Cogen.css';
import { Header, Footer } from './Container';
import { useEffect, useState } from 'react';
import { jobRequest } from '../store/jobOpportunities/async-actions';
import moment from 'moment';
import { Multiselect } from 'multiselect-react-dropdown';
import { ReqGet } from '../config/Requests';
import { ArchiveIcon } from '@primer/octicons-react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { jobListRequestInitiated } from '../store/jobOpportunities/reducer';

function HistoryDetail(props) {
	// const { id, error } = props;
	const [jobHistory, setJobHistory] = useState(false);
	const [data, setData] = useState({});
	const location = useLocation();

	const navigate = useNavigate();

	const dispatch = useDispatch();

	const jobList = () => dispatch(jobListRequestInitiated());
	const isSuccess = useSelector(state => state.data.isSuccess);
	const isIntited = useSelector(state => state.data.isIntited);

	const getIdFromPath = pathName => pathName?.split('/')?.reverse()[0];
	const error = useSelector(state =>
		getIdFromPath(state?.router?.location?.pathname)
	);

	// const error = getIdFromPath(location.pathname);
	// const id = useSelector(state => state.data.errorMessage);
	const { id } = useParams();

	useEffect(() => {
		ReqGet('jobs/history?id=' + id)
			.then(res => {
				setJobHistory(res.data);
			})
			.catch(err => {
				console.log(err);
			});
	}, []);

	const startDate = moment(data.start_date).format('MM-DD-YYYY');
	const endDate = moment(data.end_date).format('MM-DD-YYYY');

	useEffect(() => {
		if (jobHistory === undefined || jobHistory.length === 0) {
			// props.jobList();
			if (isSuccess && isIntited) {
				return;
			} else {
				ReqGet('jobs', null, {})
					.then(res => {
						if (!res.data.data) {
							// dispatch(jobListRequestFailed('Data not found'));
						} else {
							// dispatch(jobListRequestSuccess(res.data.data));
							return res.data.data;
						}
					})
					.catch(err => {
						// dispatch(jobListRequestFailed(err.message));
					});
			}
		}
	}, []);

	useEffect(() => {
		if (!jobHistory) return;

		const job = jobHistory.find(item => {
			return item.id === parseInt(id);
		});

		if (!job) navigate(`/job/${id}`);

		setData(job);
	}, [jobHistory]);

	if (error) {
		return <p>Jobs can't be loaded</p>;
	}

	return (
		<Container fluid='true' className='container-bg pb-1'>
			<Header type='member' />
			<Container fluid='md' className='container-bg'>
				<div
					style={{
						backgroundColor: '#a5a3a3',
						borderStartEndRadius: 10,
						borderStartStartRadius: 10,
						position: 'sticky',
					}}
					className='mt-2'
				>
					<Row className='justify-content-center'>
						<ArchiveIcon /> This Job is Archived
					</Row>
				</div>
				<div
					className='job-detail-wrapper px-5'
					style={{ borderEndStartRadius: 10, borderEndEndRadius: 10 }}
				>
					{data && (
						<Row>
							<Col key={data.user_id} className='p-0'>
								<Link to='/'>
									<Button variant='outline-primary btn-back-main mt-4'>
										Back
									</Button>
								</Link>
								<Card className='mt-3 mb-2'>
									<h4 className='p-3'>Job Detail</h4>
									<Card.Body>
										<Card.Text className='text-job-orange'>
											Client ID #: {data.user_id}
										</Card.Text>
										<Card.Title className='text-primary small p-1 fw-bold'>
											{data.title}
										</Card.Title>
										<hr />
										<div>
											<Card.Text className='text-job-orange'>
												{data.title} | {data.travel_type && 'Required Travel |'}{' '}
												{data.job_type == 'fullTime' && 'Full Time |'}{' '}
												{data.job_type == 'halfTime' && 'Half Time |'}{' '}
												{data.job_type == 'both' && 'Full & half time |'}{' '}
												{data.job_location == 'remote' && 'Remote'}{' '}
												{data.job_location == 'both' && 'Remote & On-site'}{' '}
												{data.job_location == 'onsite' && 'On-site'}
											</Card.Text>
											{/* <Card.Text className="text-job-orange">Requirements</Card.Text> */}
											<br />
											<Card.Text className='text-job-orange'>General</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<p>{data.description}</p>
											</Card.Text>

											<Card.Text className='text-job-orange'>
												Specific qualifications
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<p>{data.specific_qualification}</p>
											</Card.Text>
											<Card.Text className='text-job-orange'>
												No. of Positions
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.max_applicants}
											</Card.Text>
											<Card.Text className='text-job-orange'>Tags</Card.Text>
											<Card.Text className='text-job-normal mb-4 cancel-rmv'>
												<Multiselect
													closeIcon={'this'}
													options={data.tags}
													placeholder=''
													displayValue='display_name'
													selectedValues={data.tags}
													disable='true'
													style={{
														chips: { background: 'blue' },
														searchBox: {
															border: 'hidden',
															background: 'white',
														},
														closeIcon: { fontSize: '0px' },
													}}
												/>
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Job Type
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.job_type == 'fullTime' && 'Full Time'}{' '}
												{data.job_type == 'halfTime' && 'Half Time'}{' '}
												{data.job_type == 'both' && 'Full & half time'}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Job Requesting Manager
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.job_requesting_manager}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Job Location
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.job_location == 'remote' && 'Remote'}{' '}
												{data.job_location == 'both' && 'Both'}{' '}
												{data.job_location == 'onsite' && 'On-site'}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Travel Type
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.travel_type == 'InState' && 'In state'}{' '}
												{data.travel_type == 'Domestic' && 'Domestic'}{' '}
												{data.travel_type == 'International' && 'International'}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Duration of travel
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.travel_duration}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Onsite Meetings
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<p>
													{data.onsite_meetings == 'no' && 'No'}{' '}
													{data.onsite_meetings == 'yes' && 'Yes'}
												</p>
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Security clearance level
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.security_level}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Pay rate range
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.start_pay_range}-{data.end_pay_range} per month
											</Card.Text>

											<Card.Text className='text-job-orange'>
												Specific Expertise
											</Card.Text>
											{data?.specific_expertise?.map((data, index) => (
												<p key={index} className='text-job-normal mb-1'>
													{data}
												</p>
											))}
											<br />
											<Card.Text className='text-job-orange'>Tools</Card.Text>
											{data?.tool?.map((data, index) => (
												<p key={index} className='text-job-normal mb-1'>
													{data}
												</p>
											))}
											<br />
											<Card.Text className='text-job-orange'>
												Other Requirements
											</Card.Text>
											{data?.other_requirements?.map((data, index) => (
												<p key={index} className='text-job-normal mb-1'>
													{data}
												</p>
											))}
											<br />
											<Card.Text className='text-job-orange'>Dates</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<span>
													Start Date:
													{startDate}
												</span>
												<br />
												<span>
													End date:
													{endDate}
												</span>
											</Card.Text>
											<Card.Text className='text-job-orange'>State</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data?.state?.name}
											</Card.Text>
											<Card.Text className='text-job-orange'>City</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data?.city?.name}
											</Card.Text>
										</div>
									</Card.Body>
								</Card>
							</Col>
						</Row>
					)}
				</div>
			</Container>
			<Footer />
		</Container>
	);
}

export default HistoryDetail;
